import { Routes } from '@angular/router';

export const routes: Routes = [
    { path: '', loadComponent: () => import('./features/marketplace/marketplace.component').then(module => module.TaasMarketplaceComponent) },
    { path: 'help', loadComponent: () => import('./features/help/help.component').then(module => module.TaasHelpComponent) },
    { path: 'product/:id', loadComponent: () => import('./features/product-details/product-details.component').then(module => module.TaasProductDetailsComponent) },
];
